module.exports = __webpack_public_path__ + "static/media/vegitables_29.eeba6db3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_29.csv
// module id = 612
// module chunks = 0